import styled from "styled-components";

/* ── Display & sound settings surface ─────────────────────────────────── */

export const ConfigPage = styled.div`
  width: 100%;
  padding-top: 8px;
`;

/* Full-width container; keeps the page background (no nested card surface) */
export const ConfigPanel = styled.div`
  width: 100%;
`;

/* Holds the grouped sections */
export const PanelBody = styled.div`
  width: 100%;
`;

/* One settings group (Display / Sound) */
export const Section = styled.section`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 16px 48px;
  padding: 28px 0;
  border-bottom: 1px solid ${props => props.theme.colors.borderColor};

  &:last-child {
    border-bottom: none;
  }
`;

export const SectionHead = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 1 220px;
  min-width: 0;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: ${props => props.theme.font.normal};
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
`;

export const SectionDesc = styled.p`
  margin: 6px 0 0;
  font-size: ${props => props.theme.font.small};
  color: ${props => props.theme.colors.textSecondary};
  line-height: 1.5;
`;

export const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 340px;
  min-width: 0;
`;

/* Wrapper giving non-slider controls the same divided-row rhythm as sliders */
export const Item = styled.div`
  min-width: 0;
  padding: 16px 0;
  border-bottom: 1px solid ${props => props.theme.colors.borderColor};

  &:last-child {
    border-bottom: none;
  }
`;

/* Footer action bar */
export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 0;
  margin-top: 8px;
  border-top: 1px solid ${props => props.theme.colors.borderColor};
`;
